
import { IPromotionCode } from '../interface/promotion-code';
export class PromotionCode implements IPromotionCode {
    constructor(public Id: number, public Description: string,
        public Code: string, public  DiscountPercentage: number, public StartDate: string,
        public EndDate: string, public IsActive: boolean, public Parameter: string, public DiscountAmount: number,
        public Address: string, public ReferringAgency: string, public UserId: number, public IsBDA: boolean) {
    }
}



// WEBPACK FOOTER //
// ./src/app/section/master/model/promotion-code.ts